// Variable global para controlar el estado de envío (debounce)
let contactFormSubmitting = false;

$("#contact_form").submit(function(event) {
    event.preventDefault();

    const $form = $(this);
    const $feedback = $('.js-feedback');
    const $submitBtn = $form.find('button[type="submit"]');

    // Validación del teléfono
    const phoneVal = $form.find('#phone').val().trim();
    const phoneError = document.getElementById('phone-error');
    phoneError.classList.add('hidden');
    phoneError.textContent = '';

    if (!phoneVal) {
        phoneError.textContent = 'El teléfono es obligatorio.';
        phoneError.classList.remove('hidden');
        $form.find('#phone')[0].focus();
        return false;
    }
    if (!/^(?:\+34|0034|34)?[\s-]?[6-9](?:[\s-]?\d){8}$/.test(phoneVal)) {
        phoneError.textContent = 'Por favor, introduce un teléfono válido (ej: 666 123 456 o +34 93 123 45 67).';
        phoneError.classList.remove('hidden');
        $form.find('#phone')[0].focus();
        return false;
    }

    // Debounce: Prevenir envíos múltiples
    if (contactFormSubmitting) {
        console.warn('Formulario ya se está enviando. Por favor, espera...');
        return false;
    }

    // Marcar como enviando
    contactFormSubmitting = true;

    // Deshabilitar botón y cambiar apariencia
    $submitBtn.prop('disabled', true).css('opacity', '0.6').css('cursor', 'not-allowed');

    $feedback.html('').hide();

    // Ejecutar reCAPTCHA v3
    if (typeof grecaptcha !== 'undefined') {
        const siteKey = $form.data('recaptcha-site-key');
       // console.log('grecaptcha available, siteKey:', siteKey);
        if (siteKey) {
            grecaptcha.execute(siteKey, { action: 'contact_form' })
                .then(function(token) {
                    //console.log('reCAPTCHA token received:', token.substring(0, 20) + '...');
                    // Asignar token al campo oculto
                    document.getElementById('g-recaptcha-response').value = token;

                    // Enviar formulario con token
                    submitContactForm($form, $feedback, $submitBtn);
                })
                .catch(function(_error) {
                    //console.error('reCAPTCHA error:', error);
                    showContactFeedback('Error al procesar el formulario. Por favor, intenta de nuevo.', 'error', true);
                    enableContactFormSubmit($submitBtn);
                });
        } else {
            //console.warn('No reCAPTCHA site key found');
            // Si no hay site key, enviar sin reCAPTCHA (fallback)
            submitContactForm($form, $feedback, $submitBtn);
        }
    } else {
        //console.warn('grecaptcha not available, sending without reCAPTCHA');
        // Si reCAPTCHA no está disponible, enviar sin token (fallback)
        submitContactForm($form, $feedback, $submitBtn);
    }
});

function submitContactForm($form, _$feedback, $submitBtn) {
    const formData = $form.serialize();

    $.ajax({
        url: $form.data('action'),
        type: 'POST',
        data: formData,
        dataType: 'json',
        success: function(response) {
            //console.log('=== Respuesta exitosa del servidor ===');
            //console.log('Response:', response);

            // Manejar éxito (estructura: {success: 1, message})
            if (response.success == 1) {
                //console.log('✓ Formulario enviado exitosamente');
                $form[0].reset();
                showContactFeedback(response.message, 'success', true);
            }
            // Manejar error de servidor (estructura: {success: 0, message})
            else if (response.success == 0) {
                //console.error('✗ Error del servidor:', response.message);
                showContactFeedback(response.message, 'error', true);
            }
            // Estructura desconocida
            else {
                //console.warn('Estructura desconocida:', response);
                showContactFeedback('Se produjo un error inesperado. Por favor, intenta de nuevo.', 'error', true);
            }

            // Re-habilitar botón después de éxito
            enableContactFormSubmit($submitBtn);
        },
        error: function(xhr, _status, _error) {
            //console.error('=== Error en la petición AJAX ===');
            //console.error('Status HTTP:', xhr.status);
            //console.error('Status text:', status);
            //console.error('Error:', error);

            // Manejar errores de validación (422 - Validation Error)
            if (xhr.status === 422) {
                console.error('Error de validación del formulario');
                try {
                    const response = JSON.parse(xhr.responseText);
                    console.error('Validation errors:', response.errors);
                    console.error('Message:', response.message);

                    if (response.errors && Object.keys(response.errors).length > 0) {
                        const errorMessage = response.message || 'Por favor, revisa los errores en el formulario.';
                        showContactFeedback(errorMessage, 'error', true, response.errors);
                    } else {
                        showContactFeedback(response.message || 'Error de validación', 'error', true);
                    }
                } catch (e) {
                    console.error('Error parsing response:', e);
                    showContactFeedback('Error de validación. Por favor, intenta de nuevo.', 'error', true);
                }
            }
            // Otros errores HTTP
            else {
                //console.error('Response text:', xhr.responseText);
                showContactFeedback($form.data('default_error_msg') || 'Error en la petición. Por favor, intenta de nuevo.', 'error', true);
            }

            // Re-habilitar botón después de error para reintentar
            enableContactFormSubmit($submitBtn);
        }
    });
}

// Limpiar error de teléfono mientras el usuario escribe
$(document).on('input', '#phone', function() {
    const phoneError = document.getElementById('phone-error');
    if (phoneError) {
        phoneError.classList.add('hidden');
        phoneError.textContent = '';
    }
});

function enableContactFormSubmit($submitBtn) {
    // Permitir nuevos envíos
    contactFormSubmitting = false;

    // Re-habilitar botón visualmente
    $submitBtn.prop('disabled', false).css('opacity', '1').css('cursor', 'pointer');
}

function showContactFeedback(message, type = 'success', expires = false, errors = {}) {
    const feedback = document.querySelector('.js-feedback');
    feedback.innerHTML = '';

    const container = document.createElement('div');
    container.className = `p-4 rounded-lg mb-2 text-sm ${
        type === 'success' ? 'text-green-800' :
        type === 'warning' ? 'text-yellow-800' :
        'text-red-800' // error
    }`;

    if(Object.keys(errors).length > 0){
        const ul = document.createElement('ul');
        ul.className = 'list-disc pl-5';
        Object.values(errors).forEach(errArr => {
            errArr.forEach(err => {
                const li = document.createElement('li');
                li.innerText = err;
                ul.appendChild(li);
            });
        });
        container.appendChild(ul);
    } else {
        container.innerText = message;
    }

    feedback.appendChild(container);
    $(feedback).fadeIn();

    if(expires){
        setTimeout(() => {
            feedback.innerHTML = '';
            $(feedback).fadeOut();
        }, 6000);
    }
}
